export const overallReportstub = {
    "assessmentDetails": {
        "name": "Conversive (SMS Magic)"
    },
    "type": "OVERALL",
    "userDetails": {
        "name": "Mohd Fazal",
        "email": "mf4357452@gmail.com",
        "phoneNumber": "9680304392",
        "countryCode": null,
        "resume": "https://storage.googleapis.com/matrix-assessment-user/resume/e3357ba0-0174-42c2-91e7-961ef0dc81c4.pdf",
        "socialMediaLinks": [
            {
                "type": "github",
                "link": "https://github.com/mohdfazal"
            }
        ],
        "photoUrl": "https://storage.googleapis.com/accio-proctor/violations/cad6bfa9-7a25-4a53-a7be-56014c5d368d/user-photo/007ed3d2-1262-43f7-91c4-5e19bc1139ef.png"
    },
    "tagWiseScorePercentage": {},
    "totalAssessmentTime": 4212,
    "feedback": "The candidate demonstrated a solid understanding of various technical concepts, particularly in solving algorithmic problems related to graphs and patterns using DFS and stack. The candidate also effectively solved an abstract reasoning question, showing strong logical thinking skills. However, there were issues with SQL syntax and handling Flask API character limit validation.",
    "strongAreas": [
        "Graphs",
        "DFS",
        "Stack",
        "Abstract Reasoning"
    ],
    "weakAreas": [
        "SQL",
        "Flask API"
    ],
    "proctorResponses": [
        {
            "label": "Tab Switched",
            "value": 0
        },
        {
            "label": "Out of Frame",
            "value": 3
        },
        {
            "label": "Clicked Outside Window",
            "value": 1
        },
        {
            "label": "Multiple Faces Detected",
            "value": 0
        },
        {
            "label": "External Monitor Detected",
            "value": false
        },
        {
            "label": "Fullscreen Exited",
            "value": false
        },
        {
            "label": "Extension Detected",
            "value": false
        }
    ],
    "trustScore": 0.9896907,
    "totalMarks": "81"
}

export const questionwiseReportStub = {
    "assessmentDetails": {
        "name": "Conversive (SMS Magic)"
    },
    "type": "QUESTION_WISE",
    "questions": [
        {
            "tags": [],
            "questionStatement": "SMS-Magic is planning to implement a new feature to automate the process of sending follow-up messages to customers who have not responded to their initial message. The feature should be able to send a series of three follow-up messages at intervals of 3, 7, and 14 days after the initial message. \n\nThe follow-up messages should be customized based on the customer's region and language. The system should be able to handle a large volume of customers and send messages efficiently.\n\nWrite a Python script that defines a function `send_follow_up_messages` which takes a list of customer objects as input. Each customer object has the following attributes: `customer_id`, `region`, `language`, `initial_message_sent_at`. The function should use the `datetime` and `pytz` modules to calculate the appropriate time to send each follow-up message and then log the message to be sent.\n\nAssume that the `send_message` function is already implemented and available to send the actual message. You can use the `pytz` module to handle timezones.\n\nPlease write the Python script to implement the `send_follow_up_messages` function.\n\n**Note:** You can use any Python modules or libraries to achieve the task. However, please ensure that your script is efficient and scalable to handle a large volume of customers.",
            "expectedTimeToSolveForStudent": 720,
            "maxScore": 60,
            "userResponse": "Import datetime, pytz\r\n#Function\r\nsend_follow_up_messages(sustomers):\r\nForm customer in suxtomer details:\r\ncustomer_id = suxtomer[\"suxtomer_id\"]\r\nregion = sustomer[\"region\"]\r\nlanguage = customer[\"language\"]\r\ninitial_message_sent_at = customer[\"initial_message_sent_sent_at\"]\r\n\r\ninitial_dattime object initial_dattime = parse_datetime_with_timezone(initial_message_sent_at,region)\r\n\r\nfollow_up_1 = initial_date + timedelta(day=3)\r\nfollow_up_3 = initial_datetime + timedelta(days=7)\r\nfollw_up_3 = initial_datetime + timedelta(days=14)\r\n\r\ncurre",
            "feedback": "The candidate demonstrated an understanding of the problem requirements and made a good attempt to write the function. However, there are several issues with variable names and syntax errors which hinder the completion of the script. The logic behind calculating follow-up dates is correct, but more attention to detail is needed in handling customer information and datetime operations.",
            "obtainedScore": 35,
            "type": "PSEUDO_CODE",
            "timeTakenByStudent": 720
        },
        {
            "tags": [],
            "questionStatement": "A social media company, \"ConnectMe\", wants to design a database to store information about its users and their posts. The company has a requirement to store the user's personal information, their post details, and the comments on each post. \n\nThe database has three tables: `Users`, `Posts`, and `Comments`. The `Users` table has columns `userId` (primary key), `name`, `email`, and `age`. The `Posts` table has columns `postId` (primary key), `userId` (foreign key referencing the `Users` table), `postContent`, and `postDate`. The `Comments` table has columns `commentId` (primary key), `postId` (foreign key referencing the `Posts` table), `commentContent`, and `commentDate`.\n\nWrite a SQL query to insert a new user, create a new post for that user, and add a comment to that post. Assume the `userId`, `postId`, and `commentId` are auto-incrementing.\n\n```\nUsers table:\n+---------+-------+---------+-----+\n| userId | name | email  | age |\n+---------+-------+---------+-----+\n\nPosts table:\n+---------+---------+--------------+------------+\n| postId | userId | postContent  | postDate  |\n+---------+---------+--------------+------------+\n\nComments table:\n+------------+---------+---------------+------------+\n| commentId | postId | commentContent | commentDate |\n+------------+---------+---------------+------------+\n```\n\nWrite your SQL query to perform the required operations.",
            "expectedTimeToSolveForStudent": 720,
            "maxScore": 30,
            "userResponse": "#1- Create the users tale\r\nCREATE TABLE Users(\r\n    userId INT AUTO_INCREMENT PRIMARY KEY,\r\n     name VARCHAR(255) UNIQUE, age INT):\r\n\r\n     #2 Create the Posts table \r\n     CREATE TABLE Posts(\r\n        postId INT AUTO_INCREMENT PRIMARY KEY, userId INT, postContent TEXT, postDate   DATETIME, FOREIGN KEY(  userId  REFERENCES UNIQUESERS((userID)):\r\n        \r\n        #3 create the comments table \r\n        CREATE TABLE CREATE Comments(\r\n            commentId INT AUTO_INCREMETN RIMARY KEY,\r\n\r\n            postId INT,\r\n            commentContent Text,\r\n            commentDate DATETIme,\r\n            FOEIGN KEY (postId) REferneces Posts(postId)):\r\n\r\n            #4 Insert data into Users table\r\n            INSERT INTO Users(name, email, age)\r\n            VALUES('John Doe', \"joshn@examle.com\", 25):\r\n\r\n            #5 insert dat into posts tableINSERT INTO Posts(userId, postContent , postDate) BALUES (1, 'This is my first post!', NOSW()):\r\n\r\n            #6 Insert dat int o comments table \r\n            INSERT INTO commentDAte)) VALUES (1, 'Great post!',nOW()):\r\n\r\n            #7 QUERY TO FETCH AL POSTS WITH USER DETAILS \r\n            SELECT Posts.postId, Users.name,\r\n            Posts.postContent , Posts.postDate FORM PostsINNER JOIN Users ON Po\r\n        ))\r\n     )\r\n)",
            "feedback": "The candidate attempted to answer the question but did not fully meet the requirements. The response included syntax errors and incomplete SQL statements. However, the overall logic of creating tables and inserting data was correct. Improvements are needed in understanding foreign key constraints and writing complete SQL queries.",
            "obtainedScore": 15,
            "type": "PSEUDO_CODE",
            "timeTakenByStudent": 720
        },
        {
            "tags": [],
            "questionStatement": "# Number of Enclaves\n\nYou are given an `m x n` binary matrix grid, where 0 represents a sea cell and 1 represents a land cell.\n\nA move consists of walking from one land cell to another adjacent (4-directionally) land cell or walking off the boundary of the grid.\n\nReturn the number of land cells in grid for which we cannot walk off the boundary of the grid in any number of moves.\n\n### Input Format\n\nFirst line consists of the number of rows `m` and columns `n` of the matrix `mat`\n\nThe next `m` lines contains `n` integers each, either 0(sea) or 1(land)\n\n### Output Format\n\nPrint the number of land cells in grid for which we cannot walk off the boundary of the grid in any number of moves\n\n### Example 1\n\n**Input**\n\n```\n4 4\n0 0 0 0\n1 0 1 0\n0 1 1 0\n0 0 0 0\n```\n\n**Output**\n\n```\n3\n```\n\n**Explanation**\n\nThere are three 1s that are enclosed by 0s, and one 1 that is not enclosed because its on the boundary.\n\n### Example 2\n\n**Input**\n\n```\n4 4\n0 1 1 0\n0 0 1 0\n0 0 1 0\n0 0 0 0\n```\n\n**Output**\n\n```\n0\n```\n\n**Explanation**\n\nAll 1s are either on the boundary or can reach the boundary.\n\n### Constraints\n\n`m == grid.length`\n\n`n == grid[i].length`\n\n`1 <= m, n <= 500`\n\n`grid[i][j] is either 0 or 1`",
            "expectedTimeToSolveForStudent": 1800,
            "maxScore": 80,
            "userResponse": "{\"userCode\":\"import java.util.*;\\n\\npublic class Main {\\n\\n  public static void main(String[] args) {\\n    Scanner sc = new Scanner(System.in);\\n    int m = sc.nextInt(), n = sc.nextInt();\\n    int[][] grid = new int[m][n];\\n    for (int i = 0; i < m; i++) {\\n      for (int j = 0; j < n; j++) {\\n        grid[i][j] = sc.nextInt();\\n      }\\n    }\\n    sc.close();\\n    System.out.println(numEnclaves(grid));\\n  }\\n\\npublic static void dfs(int[][] grid, int i, int j){\\n  int m =  grid.length;\\n  int n = grid[0].length;\\n  if(i<0 || j<0 || i>=m || j>=n ||grid[i][j]==0) return;\\n\\n  grid[i][j] = 0;\\n  dfs(grid,i+1,j);\\n  dfs(grid,i-1,j);\\n  dfs(grid,i,j+1);\\n  dfs(grid,i,j-1);\\n}\\n  public static int numEnclaves(int[][] grid) {\\n    // your code here\\n    int m =  grid.length;\\n    int n =  grid[0].length;\\n\\n    for(int i =0;i<m;i++){\\n      if(grid[i][0]==1) dfs(grid,i,0);\\n      if(grid[i][n-1]==1) dfs(grid,i,n-1);\\n    }\\n    for(int j =0;j<n;j++){\\n      if(grid[0][j]==1) dfs(grid,0,j);\\n      if(grid[m-1][j] ==1) dfs(grid,m-1,j);\\n    }\\n\\n    int cnt =0;\\n    for(int i =0;i<m;i++){\\n      for(int j =0;j<n;j++){\\n        if(grid[i][j]==1){\\n          cnt++;\\n        }\\n      }\\n    }\\n    return cnt;\\n  }\\n}\",\"codeJudgeEvaluationResult\":{\"testCasesPassed\":10,\"totalTestCases\":10,\"scoresCredited\":40,\"solved\":true,\"totalTimeTaken\":4.831,\"submissionResult\":[{\"id\":3,\"description\":\"Accepted\"},{\"id\":3,\"description\":\"Accepted\"},{\"id\":3,\"description\":\"Accepted\"},{\"id\":3,\"description\":\"Accepted\"},{\"id\":3,\"description\":\"Accepted\"},{\"id\":3,\"description\":\"Accepted\"},{\"id\":3,\"description\":\"Accepted\"},{\"id\":3,\"description\":\"Accepted\"},{\"id\":3,\"description\":\"Accepted\"},{\"id\":3,\"description\":\"Accepted\"}]}}",
            "feedback": "The candidate successfully answered the question correctly using Depth First Search (DFS). The solution is efficient and meets the problem requirements. The candidate demonstrated solid technical knowledge in graphs and DFS algorithms, effectively solving for land cells that cannot walk off the boundary.",
            "obtainedScore": 80,
            "type": "CODE",
            "timeTakenByStudent": 1663
        },
        {
            "tags": [],
            "questionStatement": "# 132 Pattern\n\nGiven an array of `n` integers `nums`, a **132 pattern** is a subsequence of three integers `nums[i]`, `nums[j]` and `nums[k]` such that `i < j < k` and `nums[i] < nums[k] < nums[j]`.\n\nReturn `true` if there is a 132 pattern in `nums`, otherwise, return `false`.\n\n### Input Format\n\nInput consists of two lines.\n\nFirst line contains an integer `n` which is the number of elements in `nums`.\n\nNext line contains `n` spaced integers which represents the elements of `nums`.\n\n### Output Format\n\nReturn `true` if a 132 pattern is found otherwise return `false`.\n\n### Example 1\n\n**Input**\n\n```\n4\n1 2 3 4\n```\n\n**Output**\n\n```\nfalse\n```\n\n**Explanation**\n\nThere is no 132 pattern in the sequence.\n\n### Example 2\n\n**Input**\n\n```\n4\n3 1 4 2\n```\n\n**Output**\n\n```\ntrue\n```\n\n**Explanation** \n\nThere is a 132 pattern in the sequence: [1, 4, 2]\n\n### Example 3\n\n**Input**\n\n```\n4\n-1 3 2 0\n```\n\n**Output**\n\n```\ntrue\n```\n\n**Explanation** \n\nThere are three 132 patterns in the sequence: [-1, 3, 2], [-1, 3, 0] and [-1, 2, 0].\n\n### Constraints\n\n1 <= n <= 2*10^5\n\n-10^9 <= nums[i] <= 10^9",
            "expectedTimeToSolveForStudent": 900,
            "maxScore": 80,
            "userResponse": "{\"userCode\":\"import java.util.*;\\n\\nclass Solution {\\n    public boolean find132pattern(int[] nums) {\\n        //Write code here\\n        int n = nums.length;\\n        if(n<3) return false;\\n\\n        int minArray[] = new int[n];\\n        minArray[0] = nums[0];\\n\\n        for(int i =1;i<n;i++){\\n            minArray[i] = Math.min(minArray[i-1],nums[i]);\\n        }\\n\\n        Deque<Integer> stack = new ArrayDeque<>();\\n\\n        for(int j = n-1;j>=0;j--){\\n            if(nums[j]>minArray[j]){\\n                while(!stack.isEmpty() && stack.peek()<=minArray[j]){\\n                    stack.pop();\\n                }\\n                if(!stack.isEmpty() && stack.peek()<nums[j]){\\n                    return true;\\n                }\\n                stack.push(nums[j]);\\n            }\\n        }\\n        return false;\\n    }\\n}\\n\\npublic class Main {\\n    public static void main(String[] args) {\\n        Scanner sc = new Scanner(System.in);\\n        int n;\\n        n = sc.nextInt();\\n        int arr[] = new int[n];\\n        for (int i = 0; i < n; i++)\\n            arr[i] = sc.nextInt();\\n        Solution Obj = new Solution();\\n        boolean result = Obj.find132pattern(arr);\\n        if (result)\\n            System.out.println(\\\"true\\\");\\n        else\\n            System.out.println(\\\"false\\\");\\n        sc.close();\\n    }\\n}\",\"codeJudgeEvaluationResult\":{\"testCasesPassed\":10,\"totalTestCases\":10,\"scoresCredited\":40,\"solved\":true,\"totalTimeTaken\":2.945,\"submissionResult\":[{\"id\":3,\"description\":\"Accepted\"},{\"id\":3,\"description\":\"Accepted\"},{\"id\":3,\"description\":\"Accepted\"},{\"id\":3,\"description\":\"Accepted\"},{\"id\":3,\"description\":\"Accepted\"},{\"id\":3,\"description\":\"Accepted\"},{\"id\":3,\"description\":\"Accepted\"},{\"id\":3,\"description\":\"Accepted\"},{\"id\":3,\"description\":\"Accepted\"},{\"id\":3,\"description\":\"Accepted\"}]}}",
            "feedback": "The candidate successfully solved the problem and implemented an efficient solution using a stack to check for the 132 pattern. The approach was correct and passed all test cases, demonstrating good understanding of stacks and their application in solving the problem.",
            "obtainedScore": 80,
            "type": "CODE",
            "timeTakenByStudent": 777
        },
        {
            "tags": [],
            "questionStatement": "A social media company, \"ConnectMe\", has a feature that allows users to post updates about their favorite books. The feature uses a Flask API to handle user requests and store data in a SQL database. Recently, the development team noticed that when a user tries to post an update with more than 500 characters, the API crashes and returns a 500 error code. The team suspects that there is an issue with the character limit validation in the API code.\n\nThe given Flask API code snippet responsible for handling user requests is as follows:\n```python\n@app.route('/post_update', methods=['POST'])\ndef post_update():\n    data = request.get_json()\n    title = data['title']\n    content = data['content']\n    if len(content) > 200:  # character limit validation\n        return {'error': 'Content too long'}, 400\n    db.execute(\"INSERT INTO updates (title, content) VALUES (?, ?)\", (title, content))\n    return {'message': 'Update posted successfully'}, 201\n```\nWhat should be the correct modification to fix the bug in the above code?",
            "expectedTimeToSolveForStudent": 240,
            "maxScore": 20,
            "userResponse": "The character limit should be increased to 1000 characters.",
            "feedback": "Incorrect Answer, Correct Answer is option: 3, Reason: The database query should be modified to truncate the content before insertion. This would ensure that even if a user tries to post an update with more than 200 characters, only the first 200 characters will be stored in the database, thus preventing the API from crashing.",
            "obtainedScore": 0,
            "type": "MCQ",
            "options": [
                {
                    "optionStatement": "The character limit should be increased to 1000 characters."
                },
                {
                    "optionStatement": "The API should return a success response even if the content length exceeds 200 characters."
                },
                {
                    "optionStatement": "The database query should be modified to truncate the content before insertion."
                },
                {
                    "optionStatement": "The `len/content)` check should be replaced with `len(title + content)`."
                }
            ],
            "timeTakenByStudent": 62
        },
        {
            "tags": [],
            "questionStatement": "Solve the Task given below",
            "expectedTimeToSolveForStudent": 270,
            "maxScore": 50,
            "userResponse": "{\"outputGrid\":[[8,8,8,8,0,8,8,8,8,8,8,8,0,8,8],[8,8,8,8,0,8,8,8,8,8,8,8,0,8,8],[8,8,8,8,0,8,8,8,8,8,8,8,0,8,8],[8,8,8,8,0,8,8,8,8,8,8,8,0,8,8],[1,1,1,1,1,1,0,1,1,1,1,1,1,1,1],[1,1,1,1,1,1,0,1,1,1,1,1,1,1,1],[1,1,1,1,1,1,0,1,1,1,1,1,1,1,1],[1,1,1,1,1,1,0,1,1,1,1,1,1,1,1],[4,4,4,4,4,4,4,4,4,4,0,4,4,4,4],[4,4,4,4,4,4,4,4,4,4,0,4,4,4,4],[4,4,4,4,4,4,4,4,4,4,0,4,4,4,4],[4,4,4,4,4,4,4,4,4,4,0,4,4,4,4],[4,4,4,4,4,4,4,4,4,4,0,4,4,4,4],[2,0,2,2,2,2,2,2,2,2,2,2,2,2,2],[2,0,2,2,2,2,2,2,2,2,2,2,2,2,2],[2,0,2,2,2,2,2,2,2,2,2,2,2,2,2],[2,0,2,2,2,2,2,2,2,2,2,2,2,2,2]],\"isGridMatching\":true}",
            "feedback": "Correct Answer",
            "obtainedScore": 50,
            "type": "ARC",
            "timeTakenByStudent": 270,
            "testGrid": {
                "input": [
                    [
                        8,
                        8,
                        8,
                        8,
                        0,
                        8,
                        8,
                        8,
                        8,
                        8,
                        8,
                        8,
                        8,
                        8,
                        8
                    ],
                    [
                        8,
                        8,
                        8,
                        8,
                        8,
                        8,
                        8,
                        8,
                        8,
                        8,
                        8,
                        8,
                        8,
                        8,
                        8
                    ],
                    [
                        8,
                        8,
                        8,
                        8,
                        8,
                        8,
                        8,
                        8,
                        8,
                        8,
                        8,
                        8,
                        0,
                        8,
                        8
                    ],
                    [
                        8,
                        8,
                        8,
                        8,
                        8,
                        8,
                        8,
                        8,
                        8,
                        8,
                        8,
                        8,
                        8,
                        8,
                        8
                    ],
                    [
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        0,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1
                    ],
                    [
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4
                    ],
                    [
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4
                    ],
                    [
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        0,
                        4,
                        4,
                        4,
                        4
                    ],
                    [
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4
                    ],
                    [
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4,
                        4
                    ],
                    [
                        2,
                        2,
                        2,
                        2,
                        2,
                        2,
                        2,
                        2,
                        2,
                        2,
                        2,
                        2,
                        2,
                        2,
                        2
                    ],
                    [
                        2,
                        2,
                        2,
                        2,
                        2,
                        2,
                        2,
                        2,
                        2,
                        2,
                        2,
                        2,
                        2,
                        2,
                        2
                    ],
                    [
                        2,
                        0,
                        2,
                        2,
                        2,
                        2,
                        2,
                        2,
                        2,
                        2,
                        2,
                        2,
                        2,
                        2,
                        2
                    ],
                    [
                        2,
                        2,
                        2,
                        2,
                        2,
                        2,
                        2,
                        2,
                        2,
                        2,
                        2,
                        2,
                        2,
                        2,
                        2
                    ]
                ]
            },
            "trainGrids": [
                {
                    "input": [
                        [
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5
                        ],
                        [
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5
                        ],
                        [
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4
                        ],
                        [
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            0,
                            4,
                            4,
                            4,
                            4,
                            4
                        ],
                        [
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4
                        ],
                        [
                            4,
                            4,
                            4,
                            4,
                            0,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4
                        ],
                        [
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4
                        ],
                        [
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4
                        ],
                        [
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4
                        ],
                        [
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8
                        ],
                        [
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8
                        ],
                        [
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8
                        ],
                        [
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            0,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8
                        ],
                        [
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8
                        ],
                        [
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8
                        ]
                    ],
                    "output": [
                        [
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5
                        ],
                        [
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5,
                            5
                        ],
                        [
                            4,
                            4,
                            4,
                            4,
                            0,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            0,
                            4,
                            4,
                            4,
                            4,
                            4
                        ],
                        [
                            4,
                            4,
                            4,
                            4,
                            0,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            0,
                            4,
                            4,
                            4,
                            4,
                            4
                        ],
                        [
                            4,
                            4,
                            4,
                            4,
                            0,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            0,
                            4,
                            4,
                            4,
                            4,
                            4
                        ],
                        [
                            4,
                            4,
                            4,
                            4,
                            0,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            0,
                            4,
                            4,
                            4,
                            4,
                            4
                        ],
                        [
                            4,
                            4,
                            4,
                            4,
                            0,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            0,
                            4,
                            4,
                            4,
                            4,
                            4
                        ],
                        [
                            4,
                            4,
                            4,
                            4,
                            0,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            0,
                            4,
                            4,
                            4,
                            4,
                            4
                        ],
                        [
                            4,
                            4,
                            4,
                            4,
                            0,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4,
                            0,
                            4,
                            4,
                            4,
                            4,
                            4
                        ],
                        [
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            0,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8
                        ],
                        [
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            0,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8
                        ],
                        [
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            0,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8
                        ],
                        [
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            0,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8
                        ],
                        [
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            0,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8
                        ],
                        [
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            0,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8
                        ]
                    ]
                },
                {
                    "input": [
                        [
                            2,
                            2,
                            2,
                            2,
                            2,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            2,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            2,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            2,
                            2,
                            0,
                            2,
                            2,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            2,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            2,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            2,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            2,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            2,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            2,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            2,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            2,
                            1,
                            1,
                            1,
                            0,
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            2,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            2,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1
                        ]
                    ],
                    "output": [
                        [
                            2,
                            2,
                            2,
                            2,
                            2,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            2,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            2,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            0,
                            0,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            2,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            2,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            2,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            2,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            2,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            2,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            2,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            2,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            2,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            2,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1,
                            1
                        ]
                    ]
                },
                {
                    "input": [
                        [
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8
                        ],
                        [
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8
                        ],
                        [
                            8,
                            8,
                            8,
                            0,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8
                        ],
                        [
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            0,
                            8,
                            8,
                            8
                        ],
                        [
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            2,
                            0,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2
                        ],
                        [
                            3,
                            3,
                            3,
                            3,
                            3,
                            3,
                            3,
                            3,
                            3,
                            3,
                            3,
                            3,
                            3,
                            3,
                            3
                        ],
                        [
                            3,
                            3,
                            3,
                            3,
                            3,
                            3,
                            3,
                            0,
                            3,
                            3,
                            3,
                            3,
                            3,
                            3,
                            3
                        ],
                        [
                            3,
                            3,
                            3,
                            3,
                            3,
                            3,
                            3,
                            3,
                            3,
                            3,
                            3,
                            3,
                            3,
                            3,
                            3
                        ]
                    ],
                    "output": [
                        [
                            8,
                            8,
                            8,
                            0,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            0,
                            8,
                            8,
                            8
                        ],
                        [
                            8,
                            8,
                            8,
                            0,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            0,
                            8,
                            8,
                            8
                        ],
                        [
                            8,
                            8,
                            8,
                            0,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            0,
                            8,
                            8,
                            8
                        ],
                        [
                            8,
                            8,
                            8,
                            0,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            0,
                            8,
                            8,
                            8
                        ],
                        [
                            8,
                            8,
                            8,
                            0,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            8,
                            0,
                            8,
                            8,
                            8
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            2,
                            0,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            2,
                            0,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            2,
                            0,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            2,
                            0,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            2,
                            0,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2,
                            2
                        ],
                        [
                            3,
                            3,
                            3,
                            3,
                            3,
                            3,
                            3,
                            0,
                            3,
                            3,
                            3,
                            3,
                            3,
                            3,
                            3
                        ],
                        [
                            3,
                            3,
                            3,
                            3,
                            3,
                            3,
                            3,
                            0,
                            3,
                            3,
                            3,
                            3,
                            3,
                            3,
                            3
                        ],
                        [
                            3,
                            3,
                            3,
                            3,
                            3,
                            3,
                            3,
                            0,
                            3,
                            3,
                            3,
                            3,
                            3,
                            3,
                            3
                        ]
                    ]
                },
                {
                    "input": [
                        [
                            2,
                            2,
                            2,
                            2,
                            5,
                            5,
                            5,
                            5,
                            5,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            5,
                            5,
                            5,
                            5,
                            5,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            5,
                            5,
                            5,
                            5,
                            5,
                            4,
                            4,
                            4,
                            0,
                            4,
                            4
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            5,
                            5,
                            5,
                            5,
                            5,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            5,
                            5,
                            5,
                            5,
                            5,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            5,
                            5,
                            5,
                            5,
                            5,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            5,
                            5,
                            0,
                            5,
                            5,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            5,
                            5,
                            5,
                            5,
                            5,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            5,
                            5,
                            5,
                            5,
                            5,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            5,
                            5,
                            5,
                            5,
                            5,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            5,
                            5,
                            5,
                            5,
                            5,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            5,
                            5,
                            5,
                            5,
                            5,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            5,
                            5,
                            5,
                            5,
                            5,
                            4,
                            0,
                            4,
                            4,
                            4,
                            4
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            5,
                            5,
                            5,
                            5,
                            5,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4
                        ]
                    ],
                    "output": [
                        [
                            2,
                            2,
                            2,
                            2,
                            5,
                            5,
                            5,
                            5,
                            5,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            5,
                            5,
                            5,
                            5,
                            5,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            5,
                            5,
                            5,
                            5,
                            5,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            5,
                            5,
                            5,
                            5,
                            5,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            5,
                            5,
                            5,
                            5,
                            5,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            5,
                            5,
                            5,
                            5,
                            5,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            0,
                            0,
                            0,
                            0,
                            0,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            5,
                            5,
                            5,
                            5,
                            5,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            5,
                            5,
                            5,
                            5,
                            5,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            5,
                            5,
                            5,
                            5,
                            5,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            5,
                            5,
                            5,
                            5,
                            5,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            5,
                            5,
                            5,
                            5,
                            5,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            5,
                            5,
                            5,
                            5,
                            5,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ],
                        [
                            2,
                            2,
                            2,
                            2,
                            5,
                            5,
                            5,
                            5,
                            5,
                            4,
                            4,
                            4,
                            4,
                            4,
                            4
                        ]
                    ]
                }
            ]
        }
    ]
  }